import React from "react";

export default function CalculatorFormSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {Array(3)
        .fill(0)
        .map((_, index) => {
          return (
            <div key={index} className="animate-pulse">
              <div className="h-5 w-16 mb-1 bg-gray-300 rounded" />
              <div className="h-14 w-full bg-gray-300 border border-gray-300 rounded" />
            </div>
          );
        })}
      <div className="h-5 w-2/3 bg-gray-300 rounded animate-pulse" />
    </div>
  );
}
